module.exports = __webpack_public_path__ + "static/media/galerija_2021 (19)-min.1a82c850.jpg";